import { RoutesMap } from 'src/utils/const';

export type TutorialType =
  | 'market_research'
  | 'neighborhood_research'
  | 'market_explorer'
  | 'calculator_general'
  | 'overview_page';

/** Valid `?tutorial=` query values; keep in sync with `TutorialType`. */
export const TUTORIAL_QUERY_VALUES: TutorialType[] = [
  'market_research',
  'neighborhood_research',
  'market_explorer',
  'calculator_general',
  'overview_page',
];

export function isValidTutorialQueryValue(value: string): value is TutorialType {
  return (TUTORIAL_QUERY_VALUES as readonly string[]).includes(value);
}

/** Path + query for opening the tutorial modal (e.g. newsletters, `history.push`). */
export function buildTutorialDeepLink(type: TutorialType): string {
  return `${RoutesMap.Data}?tutorial=${encodeURIComponent(type)}`;
}

export const TUTORIAL_COURSE_HEADING = 'Course: How to use Airbtics';

export interface TutorialNavLesson {
  id: string;
  label: string;
  tutorialKey?: TutorialType;
  comingSoon?: boolean;
  children?: TutorialNavLesson[];
}

export interface TutorialNavModule {
  id: string;
  moduleLabel: string;
  lessons: TutorialNavLesson[];
}

/** Right-rail outline: modules, lessons, nested items (single source for TutorialModal nav). */
export const tutorialNavModules: TutorialNavModule[] = [
  {
    id: 'module_1',
    moduleLabel: 'Module 1 — Explorer',
    lessons: [
      {
        id: 'compare_markets',
        label: 'Compare Multiple Markets',
        tutorialKey: 'market_explorer',
      },
    ],
  },
  {
    id: 'module_2',
    moduleLabel: 'Module 2 — Overview',
    lessons: [
      { id: 'market_overview', label: 'Market Overview', tutorialKey: 'overview_page' },
      { id: 'analyze_submarkets', label: 'Analyze submarkets', tutorialKey: 'neighborhood_research' },
    ],
  },
  {
    id: 'module_3',
    moduleLabel: 'Module 3 — Calculator',
    lessons: [
      {
        id: 'analyze_property',
        label: 'Analyze a Property',
        tutorialKey: 'calculator_general',
        children: [
          { id: 'investment_analysis', label: 'Investment analysis', comingSoon: true },
          { id: 'rental_arbitrage', label: 'Rental arbitrage analysis', comingSoon: true },
          {
            id: 'vrmc_analysis',
            label: 'Property Manager Analysis',
            comingSoon: true,
          },
        ],
      },
    ],
  },
];

export const tutorialContent: Record<string, { title: string; videoId: string }> = {
  market_research: {
    title: "Find the Best Airbnb Markets with Airbtics' Market Comparison Tool",
    videoId: 'UP3PeDsaX2A',
  },
  neighborhood_research: {
    title: 'Analyze submarkets',
    videoId: 'LaflyQE_1SI',
  },
  market_explorer: {
    title: 'Compare Multiple Markets',
    videoId: 'UP3PeDsaX2A',
  },
  calculator_general: {
    title: 'Analyze a Property',
    videoId: '3QPnqiam0R0',
  },
  overview_page: {
    title: 'Market Overview',
    videoId: 'PVG4KuSbmfk',
  },
};
